<script>
	export default {
		name: 'ArrayExecuter',
		methods: {
			findArray(array, filterKey, filterValue) {
				// array = [ { filterKey: 10 }, { filterKey: 20 }, { filterKey: 30 }, ... ]
				// -> { filterKey: 10 }
				const self_ = this;

				if(self_.isEmpty(array)) { return [] }

				let subset_ = []

				if(self_.isBoolean(filterValue)) {
					if(filterValue) {
						subset_ = array.find(item => item[filterKey] == true)
					} else {
						subset_ = array.find(item => item[filterKey] != true)
					}
				} else {
					subset_ = array.find(item => {
						if(self_.isObject(item[filterKey])) {
							return item[filterKey][filterValue] == true
						} else {
							return item[filterKey] == filterValue
						}
					})
				}

				return subset_
			},
			filterArray(array, filterKey, filterValue) {
				// array = [ { filterKey: 10 }, { filterKey: 20 }, { filterKey: 30 }, ... ]
				// -> [ { filterKey: 10 }, { filterKey: 20 } ]
				const self_ = this;

				if(self_.isEmpty(array)) { return [] }

				let subset_ = []

				if(self_.isBoolean(filterValue)) {
					if(filterValue) {
						subset_ = array.filter(item => item[filterKey] == true)
					} else {
						subset_ = array.filter(item => item[filterKey] != true)
					}
				} else {
					subset_ = array.filter(item => {
						if(self_.isObject(item[filterKey])) {
							return item[filterKey][filterValue] == true
						} else {
							return item[filterKey] == filterValue
						}
					})
				}

				return subset_
			},
			objectArray(array, key) {
				// array = [ { key: 'a', filterKey: 10 }, { key:'b', filterKey: 20 }, { key: 'c', filterKey: 30 }, ... ]
				// -> object = { a: { filterKey: 10 }, b: { filterKey: 20 }, c: { filterKey: 30 }, ... }
				const self_ = this;
				
				if(self_.isEmpty(array)) { return {} }

				let key_ = null;
				if(self_.isFalse(key)) { key_ = 'key' }
				else { key_ = key }

				let obj_ = {}

				array.forEach(item => {
					const objectKey_ = item[key_]
					obj_[objectKey_] = item;
				})

				return obj_
			},
			sortArray(targetArray, sortKey, orderType) {
				// targetArray = [
				//		{
				//			sortKey: x,
				//			...
				//		}, ...
				// ]
				const self_ = this;

				if(self_.isFalse(sortKey)) { sortKey = 'order' }
				if(self_.isFalse(orderType)) { orderType = 'asc' }

				targetArray.sort((a, b) => {
					// descending sort
					if (orderType == 'desc' || orderType == 'descending') {
						return (a[sortKey] < b[sortKey]) ? 1 : (a[sortKey] > b[sortKey]) ? -1 : 0
					// ascending sort ( default )
					} else {
						return (a[sortKey] > b[sortKey]) ? 1 : (a[sortKey] < b[sortKey]) ? -1 : 0
					}
				})

				return targetArray
			}
		}
	}
</script>